import { Navigate } from "react-router-dom";

export default function ProtectedAdminRoute() {
  const user = JSON.parse(localStorage.getItem("user"));

  if (!user || user.email !== "fernando@telesca.com.br") {
    return <Navigate to="/" replace />;
  }

  const AdminDashboard = require("../pages/admin/AdminDashboard").default;
  return <AdminDashboard />;
}
